import React, { useState } from "react";
import { InputField } from "../../components";
const GenerateTaksModal = ({ handleModal, data, generateChildTask }) => {
  const [form, setForm] = useState({
    domain: "",
    keyword: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (value.trim() !== "") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();

    const newErrors = {};
    if (!form.domain.trim()) newErrors.domain = "Domain is required";
    if (!form.keyword.trim()) newErrors.keyword = "Keyword is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const payload = {
      ...data,
      ...form,
    };

    const confirmed = window.confirm(
      "Do you want to create a child task for this parent task?"
    );
    if (confirmed) {
      generateChildTask(payload);
    } else {
      handleModal(); 
    }
  };

  return (
    <form>
      <div className="grid md:grid-cols-1 gap-4 w-full">
        <InputField
          label="Domain"
          name="domain"
          placeholder="Enter Domain"
          value={form.domain}
          onChange={handleChange}
          error={errors.domain}
        />
      </div>

      <div className="grid md:grid-cols-1 gap-4 w-full mt-4">
        <InputField
          label="Keyword"
          name="keyword"
          placeholder="Enter Keyword"
          value={form.keyword}
          onChange={handleChange}
          error={errors.keyword}
        />
      </div>

      <div className="flex items-center justify-end mt-5 space-x-2 text-white">
        <button
          onClick={handleModal}
          type="button"
          className="btnPrimary bg-red-500"
        >
          Cancel
        </button>

        <button
          type="submit"
          className="btnPrimary bg-green-600"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default GenerateTaksModal;
